import { z } from "zod";

/**
 * Webhook create payload. The backend contract (Alejandro, 2026-06-15) accepts
 * ONLY `{ url, is_sandbox }` — the former `name` + `events[]` fields had no
 * backend counterpart (they vanished on refetch) and were dropped.
 */
export const addWebhookSchema = z.object({
  url: z
    .string()
    .trim()
    .min(1, "Enter the endpoint URL")
    .refine((u) => /^https:\/\/.+/.test(u), "Endpoint must be a valid HTTPS URL"),
  sandbox: z.boolean(),
});

export type AddWebhookValues = z.infer<typeof addWebhookSchema>;
